import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { StorageFunctions } from '../../../general/storage';
import { TabelaPrecosService } from '../../../services/tabela-precos.service';
import { ImprimirProdutoViewModel } from 'models/produto/ImprimirProdutoViewModel';
import { markFormGroupTouched } from '@utils';

@Component({
  selector: 'app-impressao-produto',
  templateUrl: './impressao-produto.component.html',
  styleUrls: ['./impressao-produto.component.css']
})
export class ImpressaoProdutoComponent extends ModalCadastroComponent implements OnInit {

  @ViewChild('modal', { static: false }) modal: any;
  @Output() onPrint = new EventEmitter<Partial<ImprimirProdutoViewModel>>();

  form: FormGroup;

  tabelaPrecoSelecionada: number | null = null;
  tabelasPreco: any[] = [];

  userId: number;

  labels = {
    codigo: 'Código',
    pesoLiquido: 'Peso Líquido',
    nome: 'Nome',
    pesoBruto: 'Peso Bruto',
    descricao: 'Descrição',
    unidade: 'Unidade',
    aliquotaInternaICMS: 'Aliquota Interna de ICMS',
    ncm: 'NCM',
    estoqueMinimo: 'Estoque mínimo',
    custoCompra: 'Custo Compra',
    estoqueAtual: 'Estoque atual',
    precoVenda: 'Preço Saída (Cadastro)',
    tabelaPreco: 'Tabela de preços',
  };

  constructor(
    private storage: StorageFunctions,
    private tabelaPrecosService: TabelaPrecosService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.userId = this.storage.getUser()?.id;
    this.createForm();
    this.loadStorage();
    this.carregarTabelasPreco();
  }

  createForm(): void {
    this.form = new FormGroup({
      colunas: new FormGroup({
        codigo: new FormControl(false),
        nome: new FormControl(false),
        descricao: new FormControl(false),
        unidade: new FormControl(false),
        ncm: new FormControl(false),
        custoCompra: new FormControl(false),
        precoVenda: new FormControl(false),
        pesoLiquido: new FormControl(false),
        pesoBruto: new FormControl(false),
        estoqueMinimo: new FormControl(false),
        estoqueAtual: new FormControl(false),
        tabelaPreco: new FormControl(false),
        aliquotaInternaICMS: new FormControl(false),
      }),

      tabelaPrecoId: new FormControl(null)
    });

    this.form.get('colunas.tabelaPreco')?.valueChanges.subscribe(checked => {
      const control = this.form.get('tabelaPrecoId');
      if (checked) {
        control?.setValidators([Validators.required]);
      } else {
        control?.clearValidators();
        control?.setValue(null);
      }
      control?.updateValueAndValidity();
    });
  }

  onTabelaPrecoChange() {
    if (!this.form.get('colunas.tabelaPreco')?.value) {
      this.form.get('tabelaPrecoId')?.setValue(null);
    }
  }

  get storageKey(): string {
    return `user_${this.userId}_impressao_produto`;
  }

  saveStorage(): void {
    this.storage.saveDataToLocalStorage(this.storageKey, this.form.value);
  }

  loadStorage(): void {
    const data = this.storage.getDataFromLocalStorage(this.storageKey);
    if (!data) return;

    this.form.patchValue(data);
  }

  carregarTabelasPreco(): void {
    this.tabelaPrecosService.getTabelaPrecos().subscribe((res: any[]) => {
      this.tabelasPreco = res.sort((a, b) => a.id - b.id);
    });
  }

  handleOnPrint(): void {
    markFormGroupTouched(this.form);
    if (this.form.invalid) {
      return;
    }

    this.saveStorage();

    const colunas = this.form.get('colunas')?.value;
    const tabelaPrecoId = this.form.get('tabelaPrecoId')?.value;

    this.onPrint.emit({
      colunas,
      tabelaPrecoId
    });

    this.hide();
  }

  handleOnCancel(): void {
    this.hide();
  }

  handleOnClose(): void {
    this.closed.emit();
  }

  show(): void {
    this.modal.show();
  }

  private hide(): void {
    this.modal.hide();
  }
}